import * as React from "react";

/**
 * Internal dependencies.
 */
import CloseIcon from '§/src/images/svg/close.svg';
import './_button-close.scss';


const ButtonClose = ( props ) => {

  // set atom class
  const atomClassName = 'button-close';
  var atomClass = props.className != undefined ? atomClassName + ' ' + props.className : atomClassName;

  return (
    <CloseIcon { ...props } className={ atomClass } style={{maxWidth: "16px", maxHeight: "16px"}}></CloseIcon>
  )
}

export default ButtonClose
